import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/app/(core)/(auth)/login/LoginInterface.tsx");
